import React from 'react';
import { Shield, Users, Clock, DollarSign, Phone, ArrowRight, CheckCircle2, ExternalLink } from 'lucide-react';
import { credentialBadges } from '../constants/credentialBadges';
import '../styles/overview.css';

const OverviewPage = () => {
  return (
    <div className="overview-page">
      {/* Hero Section */}
      <header className="overview-header">
        <div className="overview-header-content">
          <a href="https://www.amplifyhrm.com" className="overview-logo" target="_blank" rel="noopener noreferrer">
            <img 
              src="https://customer-assets.emergentagent.com/job_69a9ffbf-3b0d-4791-80d1-6eb6aacb68ee/artifacts/5dacw0dj_Amplify%20-%20Logo.jpg" 
              alt="Amplify HR Logo" 
              loading="eager"
            />
          </a>
          <a href="https://www.amplifyhrm.com" className="overview-main-link" target="_blank" rel="noopener noreferrer">
            Visit amplifyhrm.com <ExternalLink size={16} />
          </a>
        </div>
      </header>

      <main className="overview-main">
        <section className="overview-hero">
          <div className="overview-container">
            <div className="overview-badge">
              <Shield size={16} />
              <span>THE SERVICE-FIRST PEO</span>
            </div>
            <h1 className="overview-headline">
              HR Solutions That Actually <span className="highlight">Work For You</span>
            </h1>
            <p className="overview-subheadline">
              Amplify HR is a Professional Employer Organization (PEO) that puts service first. 
              No call centers, no runarounds—just a dedicated team that knows your business.
            </p>
            <div className="overview-cta-group">
              <a href="https://www.amplifyhrm.com" className="overview-cta-primary" target="_blank" rel="noopener noreferrer">
                Learn More at amplifyhrm.com <ArrowRight size={18} />
              </a>
              <a href="tel:+18558088689" className="overview-cta-phone">
                <Phone size={18} />
                (855) 808-8689
              </a>
            </div>
          </div>
        </section>

        {/* Quick Value Props */}
        <section className="overview-values">
          <div className="overview-container">
            <h2 className="overview-section-title">Why Businesses Choose Amplify</h2>
            <div className="overview-values-grid">
              <div className="overview-value-card">
                <div className="overview-value-icon">
                  <Users size={28} />
                </div>
                <h3>Dedicated Team</h3>
                <p>Work with the same people who truly know your business—no more re-explaining every call.</p>
              </div>
              <div className="overview-value-card">
                <div className="overview-value-icon">
                  <DollarSign size={28} />
                </div>
                <h3>Transparent Pricing</h3>
                <p>No hidden fees or surprise charges. See exactly what you're paying for with itemized billing.</p>
              </div>
              <div className="overview-value-card">
                <div className="overview-value-icon">
                  <Clock size={28} />
                </div>
                <h3>Rapid Response</h3>
                <p>Same-day response and resolution is our standard—not a ticket number and a 3-day wait.</p>
              </div>
              <div className="overview-value-card">
                <div className="overview-value-icon">
                  <Shield size={28} />
                </div>
                <h3>Better Benefits</h3>
                <p>Access FirstAdvantage™ zero-deductible health plans and multi-carrier options.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Quick Stats */}
        <section className="overview-stats">
          <div className="overview-container">
            <div className="overview-stats-grid">
              <div className="overview-stat">
                <div className="overview-stat-number">15-40%</div>
                <div className="overview-stat-label">Typical Cost Savings</div>
              </div>
              <div className="overview-stat">
                <div className="overview-stat-number">Same Day</div>
                <div className="overview-stat-label">Response Time</div>
              </div>
              <div className="overview-stat">
                <div className="overview-stat-number">30-45</div>
                <div className="overview-stat-label">Day Transition</div>
              </div>
            </div>
          </div>
        </section>

        {/* Credentials */}
        <section className="overview-credentials">
          <div className="overview-container">
            <p className="overview-credentials-label">Trusted & Accredited</p>
            <div className="overview-credentials-grid">
              {credentialBadges.map((badge) => (
                <div key={badge.alt} className="overview-credential">
                  <img src={badge.src} alt={badge.alt} loading="lazy" />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="overview-final-cta">
          <div className="overview-container">
            <h2>Ready to Learn More?</h2>
            <p>Visit our main website for detailed information, case studies, and to schedule a consultation.</p>
            <div className="overview-final-actions">
              <a href="https://www.amplifyhrm.com" className="overview-cta-primary" target="_blank" rel="noopener noreferrer">
                Go to amplifyhrm.com <ArrowRight size={18} />
              </a>
              <a href="tel:+18558088689" className="overview-cta-secondary">
                <Phone size={18} />
                Call (855) 808-8689
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="overview-footer">
        <div className="overview-container">
          <p>© 2026 Amplify HR. All rights reserved.</p>
          <a href="https://www.amplifyhrm.com" target="_blank" rel="noopener noreferrer">
            amplifyhrm.com
          </a>
        </div>
      </footer>
    </div>
  );
};

export default OverviewPage;
